import { useState, useRef } from "react";
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import GridViewIcon from "@mui/icons-material/GridView";
import DrawIcon from '@mui/icons-material/Draw';
import { useNavigate } from "react-router-dom";
import { createJob } from "../api/jobRoutes";

export default function SelectContent() {


  const [anchorEl, setAnchorEl] = useState(null);
  const btnRef = useRef(null);
  const open = Boolean(anchorEl);

  const handleOpen = () => setAnchorEl(btnRef.current);
  const handleClose = () => setAnchorEl(null);
  const navigate = useNavigate();

  const items = [
    {
      type: "parse",
      icon: <CenterFocusStrongIcon fontSize="small" />,
      label: "Parse",
      iconBg: "#e8f0ff",
      iconColor: "#2563eb",
    },
    {
      type: "split",
      icon: <GridViewIcon fontSize="small" />,
      label: "Split",
      iconBg: "#fef3c7",
      iconColor: "#b45309",
    },
    {
      type: "transcribe",
      icon: <DrawIcon fontSize="small" />,
      label: "Handwriting Docs",
      iconBg: "#f0fdf4",
      iconColor: "#16a34a",
    },
  ];

  const handleCreateJob = async (type) => {
    try {
      handleClose();

      const data = await createJob(type);

      navigate(`/editor/${data.id}`);
    } catch (error) {
    }
  };

  return (
    <Box sx={{ width: 260 }}>
        <Button
            ref={btnRef}
            onClick={open ? handleClose : handleOpen}
            fullWidth
            disableElevation
            startIcon={<AddCircleIcon sx={{ color: "#fff" }} />}
            sx={{
                background:
                    "linear-gradient(135deg,#7c3aed 0%, #a855f7 100%)",
                color: "#fff",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 14,
                justifyContent: "flex-start",
                px: 1.75,
                py: 1.25,
                borderRadius: 1.5,
                boxShadow: 0,

                "&:hover": {
                    background:
                        "linear-gradient(135deg,#6d28d9 0%, #9333ea 100%)",
                    boxShadow: 0,
                },

                "& .MuiButton-startIcon": {
                    mr: 1,
                },
            }}
        >
            <Box sx={{ flex: 1, textAlign: "left" }}>
                Create job
            </Box>
        </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.5,
              width: 260,
              borderRadius: 1.5,
              boxShadow:
                "0 10px 30px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.04)",
              border: "1px solid #ececec",
            },
          },
        }}
      >
        {items.map((item) => (
          <MenuItem
            key={item.label}
            onClick={() => handleCreateJob(item.type)}
            sx={{ py: 1, px: 1.5, fontSize: 14 }}
          >
            <ListItemIcon sx={{ minWidth: 36, color: "#444" }}>
              {item.iconBg ? (
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: 1,
                    bgcolor: item.iconBg,
                    color: item.iconColor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {item.icon}
                </Box>
              ) : (
                item.icon
              )}
            </ListItemIcon>
            <ListItemText
              slotProps={{ primary: { sx: { fontSize: 14, color: "#222" } } }}
            >
              {item.label}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );

}
